import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Accessibility, CheckCircle2, Mail } from 'lucide-react';

const AccessibilityPage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Accessibility className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4">Accessibility Statement</h1>
            <p className="text-xl text-muted-foreground">Our commitment to making FundTheHope accessible to everyone</p>
          </div>

          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-foreground">Our Commitment</h2>
              <p>FundTheHope is committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply relevant accessibility standards.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground">Accessibility Features</h2>
              <div className="space-y-3">
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Keyboard navigation support throughout the site</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Screen reader compatible content</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Alt text for images</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Color contrast ratios that meet WCAG guidelines</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Resizable text without loss of functionality</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Focus indicators for interactive elements</span></div>
                <div className="flex items-start gap-3"><CheckCircle2 className="w-5 h-5 text-green-500 mt-1" /><span>Dark mode for reduced eye strain</span></div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground">Conformance Status</h2>
              <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA standards. We regularly audit our website and work to address any issues identified.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground">Feedback</h2>
              <p>We welcome your feedback on the accessibility of FundTheHope. Please let us know if you encounter accessibility barriers:</p>
              <div className="bg-card border border-border rounded-xl p-6 mt-4">
                <div className="flex items-center gap-3">
                  <Mail className="w-6 h-6 text-emerald-500" />
                  <div>
                    <p className="font-medium text-foreground">Email</p>
                    <a href="mailto:accessibility@fundthehope.com" className="text-emerald-500 hover:underline">accessibility@fundthehope.com</a>
                  </div>
                </div>
              </div>
              <p className="mt-4">We try to respond to accessibility feedback within 5 business days.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AccessibilityPage;
